export default {
  NULL: 0,
  REQUIRED: 10000
};
